import React from "react";
import DetailBox from "./DetailBox";
import { useStyles } from "./style";
import moment from "moment-timezone";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";

const ConfirmClassRequest = ({ classReqdata, message, warningMsg }) => {
  const { student, courses, mentorTime, studentTime, timezone } = classReqdata;
  const classes = useStyles();
  const formatDate = (date) => {
    return moment(date).format("DD-MM-YYYY, hh:mm A");
  };
  return (
    <div className={classes.container}>
      <p className={classes.header}>{message}</p>
      <div className={classes.detailContainer}>
        <DetailBox title={"Student"} subtitle={student.text || student} />
        <DetailBox title={"Course"} subtitle={courses.text || courses} />
        <DetailBox
          title={"Date & Time (Mentor)"}
          subtitle={`${formatDate(mentorTime)} (IST)`}
        />
        <DetailBox
          title={"Date & Time (Student)"}
          subtitle={`${formatDate(studentTime)} (${
            timezone || student?.timezoneAbbr || "CST"
          })`}
        />
      </div>
      {warningMsg && warningMsg.length && (
        <div className={classes.warningContainer}>
          <WarningRoundedIcon
            sx={{ color: "#D67200", height: "16px", width: "16px" }}
          />
          <p className={classes.warningMsg}>{warningMsg}</p>
        </div>
      )}
    </div>
  );
};

export default ConfirmClassRequest;
